module.exports = __webpack_public_path__ + "static/start-playback-59c52171279d25fa7a1fa04cc9d17f5f.png";